import { render } from "./users_manage.vue?vue&type=template&id=b2a6eb72"
import script from "./users_manage.vue?vue&type=script&lang=js"
export * from "./users_manage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__